import React, { useState, useEffect } from 'react';
import {translation} from 'helpers/utilsHelper';
import S from 'StyledBetSlip.js';

const TotalBonus = ({
    totalBonus: {
        futureBonusValue = 0,
        minOutcomeOdds = 0,
        bonusStepFrom = 0
    },
    bonus = 0,
    currencyCode,
    outcomes,
    toggleAKOBonus,
}) => {
    const outcomeCount = outcomes.filter(
        ({ outcomeOdds }) => parseFloat(outcomeOdds) >= minOutcomeOdds
    ).length;
    
    const [outcomesLeftTilBonus, setOutcomesLeftTilBonus] = useState(bonusStepFrom);

    useEffect(() => {
        if (!bonusStepFrom || bonusStepFrom - outcomeCount === 0) setOutcomesLeftTilBonus(1);
        else setOutcomesLeftTilBonus(bonusStepFrom - outcomeCount);
    }, [outcomeCount, bonusStepFrom]);

    return (
        <S.TotalBonusWrapper className="total-bonus-wrapper">
            {bonus > 0 && toggleAKOBonus ? 
                (
                    <S.FormGroup className="total-bonus">
                        <S.FormGroupText data-translation={'betSlip_customBonusTitle'}>{translation('betSlip_customBonusTitle')}</S.FormGroupText>
                        <S.FormGroupText>{bonus} {currencyCode}</S.FormGroupText>
                    </S.FormGroup>
                ) 
            : null}
            {minOutcomeOdds > 0 && futureBonusValue > 0 && (
                <S.TotalBonusAdditionalInfoWrapper>
                    {(bonus < 250_000) && (
                        <>
                        {outcomeCount >= bonusStepFrom ?
                            <S.TotalBonusAdditionalInfoText data-translation={'betSlip_customBonusConditionsCompleted'}>{translation('betSlip_customBonusConditionsCompleted')}</S.TotalBonusAdditionalInfoText>
                        :
                            <S.TotalBonusAdditionalInfoText data-translation={'betSlip_customBonusAdditionalInfo'} dangerouslySetInnerHTML={{ __html: translation(outcomesLeftTilBonus === 1 ? 'betSlip_customBonusAdditionalInfoOne' : 'betSlip_customBonusAdditionalInfo', [futureBonusValue, minOutcomeOdds, outcomesLeftTilBonus]) }} />
                        }
                        </>
                    )}
                    {(bonus >= 250_000) && (
                        <S.TotalBonusAdditionalInfoText data-translation={'betSlip_customBonusInfoMax'} dangerouslySetInnerHTML={{ __html: translation('betSlip_customBonusInfoMax') }} />
                    )}
                    <S.TotalBonusAdditionalInfoIcon />
                </S.TotalBonusAdditionalInfoWrapper>
            )}
        </S.TotalBonusWrapper>
    );
};

export default TotalBonus;
